<template>
  <div class="special">
    <div class="infinite-list-wrapper">
      <ul class="specialContent" infinite-scroll-disabled="disabled">
        <li
          class="specialDiv"
          v-for="(item,key) in contentInfoList"
          :key="key"
          @click="handleDetail(item.id,InfoObject.code)"
        >
          <div>
            <img :src="getImageURL(item.cover)" style="width:100%;border-radius: 5px" />
          </div>
          <div class="title">
            <!-- <span class="titleTag">专题</span> -->
            {{item.title}}
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!--   v-infinite-scroll="load" -->
</template> 
<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
export default {
  components: {},
  created() {},
  mounted() {
    this.getInfoClass();
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      InfoObject: {},
      itemList: [],
      contentInfoList: [],
      contentInfoListTotal: 0,
      currentContentId: "",
      contentParams: {
        page: 1,
        size: 10
      },
      loading: false
    };
  },
  computed: {
    noMore() {
      return false; //this.contentParams.page*this.contentParams.size > this.contentInfoListTotal
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  methods: {
    getImageURL(cover) {
      return getImageURL(cover);
    },
    getInfoClass() {
      request.getDicts().then(res => {
        this.InfoObject = res.data.filter(item => item.value === "专题")[0];
        this.getContentInfo();
      });
    },
    getContentInfo() {
      request.getResourceSubjects(this.contentParams).then(res => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.contentParams.page += 1;
        this.getContentInfo();
        this.loading = false;
      }, 2000);
    },
    handleDetail(id, type) {
      this.$router.push({ path: `/subject/details/${id}?type=${type}` });
    }
  }
};
</script>
<style lang="less" scope>
.special {
  .specialContent {
    height: 90%;
    width: 100%;
    overflow-y: scroll;
    list-style: none;
    padding: 0px;
    .specialDiv {
      padding: 0.5rem;
      width: 100%;
      border-radius: 5px;
      display: inline-block;
      .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.9rem;
        .titleTag {
          background-color: #ff7900;
          color: #fff;
          border-radius: 0.3rem;
          padding: 0.2rem;
          font-size: 0.9rem;
          margin-right: 0.1rem;
        }
      }
    }
  }
}
</style>

